/**
 * Constants file for shared data across the application
 * Contains professional categories, company sectors, and Italian provinces
 */

// Professional Categories
export const professionalCategories = [
  'Architetti',
  'Avvocati',
  'Commercialisti',
  'Consulenti Aziendali',
  'Consulenti del Lavoro',
  'Consulenti Finanziari',
  'Consulenti Fiscali',
  'Consulenti HR',
  'Consulenti IT',
  'Consulenti Legali Aziendali',
  'Consulenti Marketing',
  'Esperti Sicurezza sul Lavoro',
  'Ingegneri',
  'Medici del Lavoro',
  'Notai'
];

// Company Sectors
export const companySectors = [
  'Agenzia Viaggio',
  'Altro',
  'Commercio',
  'Energia',
  'Finanza',
  'GDO',
  'Immobiliare',
  'Industria',
  'Lavoratore Autonomo',
  'Manifatturiero',
  'Ricettivo',
  'Sanità',
  'Servizi',
  'Retail',
  'Tecnologia',
  'Trasporti e Logistica'
];

// Italian Provinces (sorted alphabetically)
export const italianProvinces = [
  'Agrigento', 'Alessandria', 'Ancona', 'Aosta', 'Arezzo', 'Ascoli Piceno', 'Asti', 'Avellino',
  'Bari', 'Barletta-Andria-Trani', 'Belluno', 'Benevento', 'Bergamo', 'Biella', 'Bologna', 'Bolzano', 'Brescia', 'Brindisi',
  'Cagliari', 'Caltanissetta', 'Campobasso', 'Caserta', 'Catania', 'Catanzaro', 'Chieti', 'Como', 'Cosenza', 'Cremona', 'Crotone', 'Cuneo',
  'Enna', 'Fermo', 'Ferrara', 'Firenze', 'Foggia', 'Forlì-Cesena', 'Frosinone',
  'Genova', 'Gorizia', 'Grosseto', 'Imperia', 'Isernia',
  'La Spezia', 'L\'Aquila', 'Latina', 'Lecce', 'Lecco', 'Livorno', 'Lodi', 'Lucca',
  'Macerata', 'Mantova', 'Massa-Carrara', 'Matera', 'Messina', 'Milano', 'Modena', 'Monza e Brianza',
  'Napoli', 'Novara', 'Nuoro', 'Oristano',
  'Padova', 'Palermo', 'Parma', 'Pavia', 'Perugia', 'Pesaro e Urbino', 'Pescara', 'Piacenza', 'Pisa', 'Pistoia', 'Pordenone', 'Potenza', 'Prato',
  'Ragusa', 'Ravenna', 'Reggio Calabria', 'Reggio Emilia', 'Rieti', 'Rimini', 'Roma', 'Rovigo',
  'Salerno', 'Sassari', 'Savona', 'Siena', 'Siracusa', 'Sondrio', 'Sud Sardegna',
  'Taranto', 'Teramo', 'Terni', 'Torino', 'Trapani', 'Trento', 'Treviso', 'Trieste',
  'Udine', 'Varese', 'Venezia', 'Verbano-Cusio-Ossola', 'Vercelli', 'Verona', 'Vibo Valentia', 'Vicenza', 'Viterbo'
].sort();

// Company Sizes
export const companySizes = [
  '1-10 dipendenti',
  '11-50 dipendenti',
  '51-200 dipendenti',
  '201-500 dipendenti',
  '500+ dipendenti'
];

// Experience Years (for professionals)
export const experienceYears = [
  { value: 1, label: '1 anno' },
  { value: 2, label: '2 anni' },
  { value: 3, label: '3 anni' },
  { value: 5, label: '5 anni' },
  { value: 10, label: '10 anni' },
  { value: 15, label: '15+ anni' }
];

// Listing Priorities
export const listingPriorities = [
  { value: 'bassa', label: 'Bassa', color: 'bg-slate-100 text-slate-600' },
  { value: 'media', label: 'Media', color: 'bg-blue-100 text-blue-700' },
  { value: 'alta', label: 'Alta', color: 'bg-red-100 text-red-700' }
];

// Countries (for location fields)
export const countries = [
  'Italia',
  'San Marino',
  'Città del Vaticano',
  'Svizzera',
  'Austria',
  'Francia',
  'Slovenia',
  'Altro'
];
